import {useDispatch, useSelector} from "react-redux";
import {useParams, useSearchParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {setCreateButton, setSearchHandler, setSearchString, setTitle} from "../actions/main";
import formater from "../helpers/formater";
import {Dropdown} from "primereact/dropdown";
import {MultiSelect} from "primereact/multiselect";
import {Tooltip} from "primereact/tooltip";
import {Button} from "primereact/button";
import {Calendar} from "primereact/calendar";
import {CashService} from "../services/CashService";
import Loader from "../components/Loader";
import {Badge} from "primereact/badge";
import {InputNumber} from "primereact/inputnumber";
import {InputSwitch} from "primereact/inputswitch";
import {InputText} from "primereact/inputtext";
import {useFormik} from "formik";
import FormGroup from "../components/FormGroup";
import {classNames} from "primereact/utils";
import {FinanceService} from "../services/FinanceService";
import {confirmDialog, ConfirmDialog} from "primereact/confirmdialog";
import {Sidebar} from "primereact/sidebar";
import {InputTextarea} from "primereact/inputtextarea";
import {EventsService} from "../services/EventsService";

export default function Cash() {

    const dispatch = useDispatch()
    const locationParams = useParams()
    const [searchParams] = useSearchParams()
    const currentDepartment = useSelector(function (state) {
        return state.currentDepartment
    });
    const [date, setDate] = useState(new Date())
    const [dialogVisible, setDialogVisible] = useState(false)
    const [cashPayments, setCashPayments] = useState(['rub', 'card'])
    const [bankPayments, setBankPayments] = useState(['credit'])
    const [rows, setRows] = useState([])
    const [eventId, setEventId] = useState(false)
    const [events, setEvents] = useState([])
    const [curEvents, setCurEvents] = useState([])
    const [loading, setLoading] = useState(true)
    const [categories, setCategories] = useState([])
    const [currentCategory, setCurrentCategory] = useState(0)

    const updateData = () => {
        const params = {
            type: [...cashPayments, ...bankPayments],
            // month: date.getMonth() + 1,
            // year: date.getFullYear(),
            client_id: currentDepartment
        }
        
        // Добавляем event_id только если он выбран
        if (eventId) {
            params.event_id = eventId
        }
        
        CashService.GetList(params).then((rows) => {
            setLoading(false)
            setRows(rows?.items || [])
        }).catch((error) => {
            console.error('Error loading cash data:', error)
            setLoading(false)
            setRows([])
        })
    }

    // base init
    useEffect(() => {
        setLoading(true)
        dispatch(setSearchString(''))
        dispatch(setSearchHandler(false))
        dispatch(setCreateButton(false))
        // dispatch(setTitle())
        dispatch(setTitle(''))
        
        // Обрабатываем параметр event_id из URL
        const eventIdFromUrl = searchParams.get('event_id')
        if (eventIdFromUrl) {
            setEventId(parseInt(eventIdFromUrl))
        }
        
        // Обрабатываем параметр create - прокручиваем к форме создания
        const shouldCreate = searchParams.get('create')
        if (shouldCreate === 'true') {
            // Прокручиваем к форме создания новой операции
            setTimeout(() => {
                const formElement = document.querySelector('form[onSubmit]')
                if (formElement) {
                    formElement.scrollIntoView({ behavior: 'smooth' })
                }
            }, 100)
        }
        
        // Предустанавливаем event_id в форме создания новой операции
        if (eventIdFromUrl) {
            formikCash.setFieldValue('event_id', parseInt(eventIdFromUrl))
        }
        
        updateData()
    }, [currentDepartment, locationParams.type, date, cashPayments, bankPayments, currentCategory, eventId, searchParams])

    useEffect(() => {
        // CashService.GetCategories().then((cats) => {
        //     let data = []
        //     Object.keys(cats).map((key) => {
        //         data.push({label: key, value: key, color: cats[key]})
        //     })
        //     setCategories(data)
        // })
        EventsService.GetList({filter: {client_id: currentDepartment}}).then((res) => {
            setEvents(res.items)
        })
    }, [currentDepartment]);

    const prevMonthHandler = (e) => {
        const d = new Date(JSON.parse(JSON.stringify(date)));
        d.setMonth(d.getMonth() - 1)
        setDate(d)
    }
    const nextMonthHandler = (e) => {
        const d = new Date(JSON.parse(JSON.stringify(date)));
        d.setMonth(d.getMonth() + 1)
        setDate(d)
    }

    const isCashEnrollment = (row) => {
        if (!row.is_cost && (row.type === 'card' || row.type === 'rub' || row.type === 'card_5')) {
            return true;
        }
        return false;
    }
    const isBankEnrollment = (row) => {
        if (!row.is_cost && (row.type === 'credit' || row.type === 'credit_5')) {
            return true;
        }
        return false;
    }

    const isCashCost = (row) => {
        if (row.is_cost && (row.type === 'card' || row.type === 'rub' || row.type === 'card_5')) {
            return true;
        }
        return false;
    }
    const isBankCost = (row) => {
        if (row.is_cost && (row.type === 'credit' || row.type === 'credit_5')) {
            return true;
        }
        return false;
    }

    const handleEditReceipt = (el) => {
        if (!el.id) {
            console.error('Cannot edit cash operation: ID is missing', el)
            return
        }
        
        formikCashEdit.setValues({
            id: el.id,
            amount: el.amount,
            is_cost: el.is_cost,
            type: el.type,
            category: el.category,
            comment: el.comment,
            date: new Date(el.created_at)
        })
        setDialogVisible(true)
    }

    const handleRemoveReceipt = (el) => {
        confirmDialog({
            message: 'Вы хотите удалить этот платеж?',
            header: 'Подтвердите удаление',
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            accept: () => {
                setLoading(true)
                CashService.Delete(el.id).then((res) => {
                    updateData()
                })
            },
            acceptLabel: 'Удалить',
            reject: () => {
                return false
            },
            rejectLabel: 'Нет'
        });
    }

    let currentCashSumm = 0
    let currentCreditSumm = 0
    let currentMainSumm = 0

    useEffect(() => {
        let f = events.find((el) => el.id === eventId)
        if(f) {
            formikCash.setFieldValue('date', new Date(f.date))
        }
    }, [eventId]);

    useEffect(() => {
        if(events){
            setCurEvents(events.filter((el) => new Date(el.date).getFullYear() === date.getFullYear() && new Date(el.date).getMonth() === date.getMonth()))
        }
    }, [date, events]);

    const formikCash = useFormik({
        initialValues: {
            date: new Date(),
            amount: null,
            is_cost: 0,
            type: 'rub',
            category: null,
            comment: '',
            id: null,
            event_id: null
        },
        validate: (data) => {
            let errors = {}

            if (!data.date) {
                errors.date = 'Укажите дату'
            }

            if (!data.amount) {
                errors.amount = 'Укажите сумму'
            }

            if (data.is_cost === '') {
                errors.is_cost = 'Укажите типа'
            }

            if (!data.type) {
                errors.type = 'Укажите тип'
            }


            return errors
        },
        onSubmit: (data) => {

            setLoading(true)

            let fetchData = {
                created_at: new Date(formater.dateWithOffset(data.date)).getTime() / 1000,
                amount: data.amount,
                is_cost: data.is_cost,
                type: data.type,
                comment: data.comment,
                date: date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + '01',
                // id: data.id,
                client_id: currentDepartment,
                event_id: data.event_id || eventId
            }

            CashService.Create(fetchData).then((res) => {
                updateData()
                formikCash.resetForm()
            })

        }
    })

    const formikCashEdit = useFormik({
        initialValues: {
            date: new Date(),
            amount: null,
            is_cost: 1,
            type: 'rub',
            category: null,
            comment: '',
            id: null
        },
        validate: (data) => {
            let errors = {}

            if (!data.date) {
                errors.date = 'Укажите дату'
            }

            if (!data.amount) {
                errors.amount = 'Укажите сумму'
            }

            if (data.is_cost === '') {
                errors.is_cost = 'Укажите типа'
            }

            if (!data.type) {
                errors.type = 'Укажите тип'
            }


            console.log(errors)

            return errors
        },
        onSubmit: (data) => {

            setLoading(true)

            let fetchData = {
                created_at: new Date(formater.dateWithOffset(data.date)).getTime() / 1000,
                amount: data.amount,
                is_cost: data.is_cost,
                type: data.type,
                comment: data.comment,
                date: date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + '01',
                // id: data.id,
                client_id: currentDepartment,
                event_id: eventId
            }

            if (data.id && data.id !== null) {
                CashService.Update(data.id, fetchData).then((res) => {
                    formikCashEdit.resetForm()
                    setDialogVisible(false)
                    updateData()
                }).catch((error) => {
                    console.error('Error updating cash operation:', error)
                    formikCashEdit.resetForm()
                    setDialogVisible(false)
                })
            } else {
                console.error('Cannot update cash operation: ID is null or undefined')
                formikCashEdit.resetForm()
                setDialogVisible(false)
            }

        }
    })

    const isCashFormFieldInvalid = (name) => !!(formikCash.touched[name] && formikCash.errors[name]);
    const isCashFormEditFieldInvalid = (name) => !!(formikCashEdit.touched[name] && formikCashEdit.errors[name]);

    return (
        <>

            <Sidebar position={'left'} className={'receipt-edit'} visible={dialogVisible}
                     onHide={() => {
                         formikCashEdit.resetForm();
                         setDialogVisible(false)
                     }}>

                <h2>Редактировать операцию</h2>
                <form className={'d-flex flex-column gap-3 m-t-20'} onSubmit={formikCashEdit.handleSubmit}>

                    <Calendar placeholder={'Дата операции'} dateFormat={'dd.mm.yy'} value={formikCashEdit.values.date}
                              onChange={(e) => formikCashEdit.setFieldValue('date', e.value)}
                              className={classNames({'p-invalid': isCashFormEditFieldInvalid('date')})}/>

                    <InputNumber mode={'currency'} currency={'RUB'} maxFractionDigits={0} placeholder={'Сумма'}
                                 className={'amount-input ' + classNames({'p-invalid': isCashFormEditFieldInvalid('amount')})}
                                 value={formikCashEdit.values.amount}
                                 onChange={(e) => formikCashEdit.setFieldValue('amount', e.value)}/>

                    <Dropdown placeholder={'Тип операции'} value={formikCashEdit.values.is_cost}
                              onChange={(e) => formikCashEdit.setFieldValue('is_cost', e.value)} options={[
                        {label: 'Приход', value: 0},
                        {label: 'Расход', value: 1}
                    ]} className={classNames({'p-invalid': isCashFormEditFieldInvalid('is_cost')})}/>
                    <Dropdown placeholder={'Способ оплаты'} options={[
                        {label: 'Наличные', value: 'rub'}, {
                            label: 'Касса +6%',
                            value: 'card'
                        }, {
                            label: 'Безнал +6%',
                            value: 'credit'
                        }, {
                            label: 'Касса +11%',
                            value: 'card_5'
                        }, {
                            label: 'Безнал +11%',
                            value: 'credit_5'
                        }
                    ]} value={formikCashEdit.values.type}
                              onChange={(e) => formikCashEdit.setFieldValue('type', e.value)}
                              className={classNames({'p-invalid': isCashFormEditFieldInvalid('type')})}/>


                    <InputTextarea autoResize={true} placeholder={'Комментарий'} className={'w-100'}
                                   value={formikCashEdit.values.comment}
                                   onChange={(e) => formikCashEdit.setFieldValue('comment', e.target.value)}/>

                    <Button loading={loading} type={'submit'} label={'Сохранить'} className={'flex-shrink-0'}/>
                </form>
            </Sidebar>

            <div className="d-flex align-items-center justify-content-between p-t-10">
                <h1>{'Касса'}</h1>

                <div className={'d-flex gap-5'}>
                    <Dropdown placeholder={'Выберите мероприятие'} options={curEvents.map((ev) => {
                        return {label: ev.name + ' (' + new Date(ev.date).toLocaleDateString() + ')', value: ev.id}
                    })} value={eventId} onChange={(e) => setEventId(e.value)} filter={true}/>

                    <div className={'d-flex gap-2 flex-shrink-0 justify-content-end p-button-group'}>
                        <Button icon={'pi pi-angle-left'} text severity="secondary"
                                onClick={(e) => prevMonthHandler()}/>

                        <Calendar
                            inputClassName={' p-component p-button-secondary p-button p-button-text'}
                            value={date} onChange={(e) => setDate(e.value)} view="month"
                            dateFormat="MM yy"/>

                        <Button icon={'pi pi-angle-right'} text severity={'secondary'}
                                onClick={(e) => nextMonthHandler()}/>
                    </div>
                </div>
            </div>
            <div className={'card project-list m-t-30'}
                 style={{'overflow': 'hidden', 'maxHeight': 'calc(100vh - 210px)'}}>


                <div className="table-responsive">
                    {loading && <div className={'p-5'}><Loader/></div>}
                    <ConfirmDialog/>
                    <Tooltip/>
                    <Tooltip target=".category-tooltip" mouseTrack mouseTrackLeft={10}/>
                    <Tooltip target=".cash-info" mouseTrack position={'left'} mouseTrackRight={10}/>

                    {eventId &&
                        <>
                            <table className="table table-cash">
                                <thead>
                                <tr>
                                    <th rowSpan={2}>Дата</th>
                                    <th colSpan={2}>
                                        <MultiSelect showSelectAll={false} tooltip={'Выберите тип операции'}
                                                     options={[{label: 'Наличные', value: 'rub'}, {
                                                         label: 'Касса +6%',
                                                         value: 'card'
                                                     }, {
                                                         label: 'Касса +11%',
                                                         value: 'card_5'
                                                     }
                                                     ]} value={cashPayments}
                                                     onChange={(e) => setCashPayments(e.value)}/>
                                    </th>
                                    <th rowSpan={2}>Остаток</th>
                                    <th colSpan={2}>
                                        <MultiSelect showSelectAll={false} tooltip={'Выберите тип операции'}
                                                     options={[{label: 'Безнал +6%', value: 'credit'}, {
                                                         label: 'Безнал +11%',
                                                         value: 'credit_5'
                                                     }]}
                                                     value={bankPayments}
                                                     onChange={(e) => setBankPayments(e.value)}/>
                                    </th>
                                    <th rowSpan={2}>Остаток</th>
                                    <th rowSpan={2}>Общий остаток</th>
                                    <th>

                                    </th>
                                </tr>
                                <tr>
                                    <th>Приход</th>
                                    <th>Расход</th>
                                    <th>Приход</th>
                                    <th>Расход</th>

                                    <th>
                                        Назначение платежа
                                    </th>
                                </tr>
                                </thead>
                                <tbody>

                                {rows.map((el) => {

                                    if (isCashEnrollment(el)) {
                                        currentCashSumm += el.amount;
                                        currentMainSumm += el.amount;
                                    }
                                    if (isCashCost(el)) {
                                        currentCashSumm -= el.amount;
                                        currentMainSumm -= el.amount;
                                    }
                                    if (isBankEnrollment(el)) {
                                        currentCreditSumm += el.amount;
                                        currentMainSumm += el.amount;
                                    }
                                    if (isBankCost(el)) {
                                        currentCreditSumm -= el.amount;
                                        currentMainSumm -= el.amount;
                                    }

                                    return (
                                        <tr key={el.id}>
                                            <td>{new Date(el.created_at).toLocaleDateString()}</td>
                                            <td className={'cash-enrollment'}> {isCashEnrollment(el) && '+' + formater.amountFormat(el.amount)}</td>
                                            <td className={'cash-cost'}> {isCashCost(el) && '-' + formater.amountFormat(el.amount)}</td>
                                            <td> {formater.amountFormat(currentCashSumm)}</td>
                                            <td className={'cash-enrollment'}> {isBankEnrollment(el) && '+' + formater.amountFormat(el.amount)}</td>
                                            <td className={'cash-cost'}> {isBankCost(el) && '-' + formater.amountFormat(el.amount)}</td>
                                            <td> {formater.amountFormat(currentCreditSumm)}</td>
                                            <td> {formater.amountFormat(currentMainSumm)}</td>
                                            <td>

                                                <div className={'d-flex gap-2 align-items-center'}>

                                                    {el.category && categories.length &&
                                                        <Badge className={'category-tooltip'} value={' '} style={{
                                                            'background': categories.find((r) => r.label === el.category).color,
                                                            'height': '10px',
                                                            'min-width': '10px'
                                                        }} data-pr-tooltip={el.category}/>}

                                                    <span>{el.table_comment ? el.table_comment : el.comment}</span>

                                                    <div className={'gap-3 cash-actions'}
                                                         style={{'marginLeft': 'auto'}}>

                                                        {!el.children_id &&
                                                            <a href={'#'} onClick={(e) => handleEditReceipt(el)}>
                                                                <i className={'pi pi-pencil'}></i>
                                                            </a>}

                                                        <a href={"#"} onClick={(e) => handleRemoveReceipt(el)}
                                                           className={'text-danger'}><i
                                                            className={'pi pi-trash'}></i></a>
                                                    </div>

                                                </div>


                                            </td>
                                        </tr>
                                    )
                                })}


                                </tbody>


                                <tfoot>
                                {rows && rows.length > 0 &&
                                    <tr>
                                        <th>
                                            <strong>Итого:</strong>
                                        </th>
                                        <th className={'cash-enrollment'}>
                                            +{formater.amountFormat(rows.filter((el) => isCashEnrollment(el)).reduce((a, b) => a + b.amount, 0))}
                                        </th>
                                        <th className={'cash-cost'}>
                                            -{formater.amountFormat(rows.filter((el) => isCashCost(el)).reduce((a, b) => a + b.amount, 0))}
                                        </th>
                                        <th>
                                            {formater.amountFormat(currentCashSumm)}
                                        </th>
                                        <th className={'cash-enrollment'}>
                                            +{formater.amountFormat(rows.filter((el) => isBankEnrollment(el)).reduce((a, b) => a + b.amount, 0))}
                                        </th>
                                        <th className={'cash-cost'}>
                                            -{formater.amountFormat(rows.filter((el) => isBankCost(el)).reduce((a, b) => a + b.amount, 0))}
                                        </th>
                                        <th>
                                            {formater.amountFormat(currentCreditSumm)}
                                        </th>
                                        <th>
                                            {formater.amountFormat(currentMainSumm)}
                                        </th>
                                        <th>

                                        </th>
                                    </tr>
                                }
                                <tr>
                                    <th colSpan={9}>
                                        <form className={'d-flex gap-3'} onSubmit={formikCash.handleSubmit}>

                                            <Calendar icon={'pi pi-calendar'} showIcon placeholder={'Дата операции'}
                                                      dateFormat={'dd.mm.yy'} value={formikCash.values.date}
                                                      onChange={(e) => formikCash.setFieldValue('date', e.value)}
                                                      className={classNames({'p-invalid': isCashFormFieldInvalid('date')})}/>

                                            <InputNumber mode={'currency'} currency={'RUB'} maxFractionDigits={0}
                                                         placeholder={'Сумма'}
                                                         className={'amount-input ' + classNames({'p-invalid': isCashFormFieldInvalid('amount')})}
                                                         value={formikCash.values.amount}
                                                         onChange={(e) => formikCash.setFieldValue('amount', e.value)}/>

                                            <Dropdown placeholder={'Тип операции'} value={formikCash.values.is_cost}
                                                      onChange={(e) => formikCash.setFieldValue('is_cost', e.value)}
                                                      options={[
                                                          {label: 'Приход', value: 0},
                                                          {label: 'Расход', value: 1}
                                                      ]}
                                                      className={classNames({'p-invalid': isCashFormFieldInvalid('is_cost')})}/>
                                            <Dropdown placeholder={'Способ оплаты'} options={[
                                                {label: 'Наличные', value: 'rub'}, {
                                                    label: 'Касса +6%',
                                                    value: 'card'
                                                }, {
                                                    label: 'Безнал +6%',
                                                    value: 'credit'
                                                },
                                                {
                                                    label: 'Касса +11%',
                                                    value: 'card_5'
                                                }, {
                                                    label: 'Безнал +11%',
                                                    value: 'credit_5'
                                                }
                                            ]} value={formikCash.values.type}
                                                      onChange={(e) => formikCash.setFieldValue('type', e.value)}
                                                      className={classNames({'p-invalid': isCashFormFieldInvalid('type')})}/>

                                            <InputText placeholder={'Комментарий'} className={'w-100'}
                                                       value={formikCash.values.comment}
                                                       onChange={(e) => formikCash.setFieldValue('comment', e.target.value)}/>

                                            <Dropdown placeholder={'Событие (необязательно)'} 
                                                      value={formikCash.values.event_id}
                                                      onChange={(e) => formikCash.setFieldValue('event_id', e.value)}
                                                      options={curEvents.map(event => ({
                                                          label: `${event.name} (${new Date(event.date).toLocaleDateString()})`,
                                                          value: event.id
                                                      }))}
                                                      showClear
                                                      className={'w-100'}/>

                                            <Button loading={loading} type={'submit'} label={'Добавить'}
                                                    className={'flex-shrink-0'}/>
                                        </form>
                                    </th>
                                </tr>
                                </tfoot>

                            </table>

                            {!rows.length && <div className={'p-5 d-flex w-100 justify-content-center'}>
                                <p>Нет операций за выбранный период.</p>
                            </div>}
                        </>
                    }

                </div>
            </div>

        </>
    )

}